import { tarifsTJM, reglesOr, TAUX, fmtRange } from '../data/tarifsData';

// ── Format FCFA/USD/EUR range for email text ──────────────
function priceRow(ligne) {
  const eurMin = Math.round(ligne.usdMin / TAUX.EUR_TO_USD);
  const eurMax = Math.round(ligne.usdMax / TAUX.EUR_TO_USD);
  return (
    `  • ${ligne.prestation}${ligne.suffix ? ' (' + ligne.suffix.replace('/','') + ')' : ''}\n` +
    `    FCFA : ${fmtRange(ligne.fcfaMin, ligne.fcfaMax, 'FCFA', ligne.suffix)}\n` +
    `    USD  : ${fmtRange(ligne.usdMin, ligne.usdMax, '$', ligne.suffix)}\n` +
    `    EUR  : ${fmtRange(eurMin, eurMax, '€', ligne.suffix)}\n`
  );
}

// ── Build admin notification email body ───────────────────
export function buildAdminEmail({ type, num, dateStr, cnom, cemail, worker, totals, contact, paiement }) {
  const fmt = n => Number(n).toLocaleString('fr-FR') + ' FCFA';
  const usd  = n => Math.round(n / TAUX.USD_TO_FCFA).toLocaleString('fr-FR') + ' $';
  const eur  = n => Math.round(n / TAUX.EUR_TO_FCFA).toLocaleString('fr-FR') + ' €';
  const typeLabel = type === 'facture' ? 'FACTURE' : 'DEVIS';

  // Build TJM confidential block
  const tjmBlock = [
    '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
    '⏱️ TARIFS JOURNALIERS (TJM) — CONFIDENTIEL',
    '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
    ...tarifsTJM.lignes.map(priceRow),
  ].join('\n');

  // Build règles d'or block
  const reglesBlock = [
    '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
    '💡 RÈGLES D\'OR — CONFIDENTIEL',
    '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
    ...reglesOr.regles.map((r, i) => `  ${i + 1}. ${r}`),
  ].join('\n');

  // Currency equivalents of total
  const totalMulti = totals.total > 0
    ? `  FCFA : ${fmt(totals.total)}\n  USD  : ${usd(totals.total)}\n  EUR  : ${eur(totals.total)}`
    : '  FCFA : 0';

  const body =
`╔════════════════════════════════════════╗
  KOTOSTECHNOLOGY — RAPPORT ADMINISTRATEUR
  ${typeLabel} N° ${num} — ${dateStr}
╚════════════════════════════════════════╝

📋 INFORMATIONS OPÉRATION
──────────────────────────
Type        : ${typeLabel}
Numéro      : ${num}
Date        : ${dateStr}
Établi par  : ${worker}
Client      : ${cnom || '—'}
Email client: ${cemail || 'Non fourni'}

💰 MONTANTS (TOUTES DEVISES)
──────────────────────────
${totalMulti}
${totals.acompte > 0
  ? `\nAcompte reçu :\n  FCFA : ${fmt(totals.acompte)}\n  USD  : ${usd(totals.acompte)}\n  EUR  : ${eur(totals.acompte)}\n\nReste à payer :\n  FCFA : ${fmt(totals.restant)}\n  USD  : ${usd(totals.restant)}\n  EUR  : ${eur(totals.restant)}`
  : ''
}

📱 MODALITÉS DE PAIEMENT
──────────────────────────
Mobile Money : ${paiement.mobile}
Bancaire     : ${paiement.bank.split('\n')[0]}
${paiement.other ? 'Autres       : ' + paiement.other : ''}

${tjmBlock}

${reglesBlock}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🏢 KOTOSTECHNOLOGY – Rapport automatique
${contact.address}
Tél : ${contact.tel} | ${contact.email}
www.kotostechnology.com
RCCM N° ${contact.rccm} · IFU : ${contact.ifu}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`;

  return body;
}

// ── Build client email body (public only — no confidential) ──
export function buildClientEmail({ type, num, dateStr, valid, cnom, worker, totals, contact, paiement }) {
  const fmt = n => Number(n).toLocaleString('fr-FR') + ' FCFA';
  const usd  = n => Math.round(n / TAUX.USD_TO_FCFA).toLocaleString('fr-FR') + ' $';
  const eur  = n => Math.round(n / TAUX.EUR_TO_FCFA).toLocaleString('fr-FR') + ' €';
  const typeLabel = type === 'facture' ? 'Facture' : 'Devis';

  return `Bonjour ${cnom || 'Client'},

Veuillez trouver ci-dessous votre ${typeLabel} N° ${num} émis par KOTOSTECHNOLOGY.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${typeLabel.toUpperCase()} N° ${num} — ${dateStr}
Établi par : ${worker}
${valid ? 'Validité : ' + valid + ' jours' : ''}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

MONTANT TOTAL :
  ${fmt(totals.total)}
  ${usd(totals.total)}
  ${eur(totals.total)}
${totals.acompte > 0
  ? `\nAcompte versé  : ${fmt(totals.acompte)}\nReste à payer  : ${fmt(totals.restant)}`
  : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
💳 MODALITÉS DE PAIEMENT
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📱 Mobile Money : ${paiement.mobile}
🏦 Bancaire     : ${paiement.bank.split('\n')[0]}
${paiement.other ? '💵 Autres       : ' + paiement.other : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
KOTOSTECHNOLOGY – JEHOVA-JIRE MULTI-SERVICES
${contact.address}
Tél : ${contact.tel}
${contact.email} · www.kotostechnology.com
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Merci de votre confiance !`;
}
